export const styles = ({ palette, breakpoints }) => ({
  fontStylesBig: {
    fontSize: 24,
  },
});
